import { z } from "zod";
export const IntervalSchemaMinutes = z.object({
    type: z.literal("MINUTES"),
    minutes: z.number()
});
export const IntervalSchemaInfinity = z.object({
    type: z.literal("INFINITY")
});
export const IntervalSchema = z.union([
    IntervalSchemaMinutes,
    IntervalSchemaInfinity
]);
export const OccurrenceSchema = z.object({
    occurrences: z.number(),
    interval: IntervalSchema
});
